import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

/**
 * /legal/privacy — public placeholder page. Full Privacy Policy will be
 * published before commercial launch. i18n scope: `legal.privacy`.
 */
export default function Privacy() {
  const { t } = useTranslation("legal");
  return (
    <LegalLayout
      testId="legal-privacy-page"
      metaTitle={t("privacy.meta_title")}
      kicker={t("privacy.kicker")}
      pageTitle={t("privacy.page_title")}
      body={t("privacy.body")}
      backHomeLabel={t("privacy.back_home")}
      contactLabel={t("common.contact_us")}
      contactEmail={t("common.contact_email")}
    />
  );
}
